import { z } from 'zod';

export const NotificationsQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
  unreadOnly: z.coerce.boolean().optional(),
});
export type NotificationsQuery = z.infer<typeof NotificationsQuerySchema>;

/** Deep-link payload carried in Notification.data and the FCM data message. */
export interface NotificationData {
  kind: 'dispatch' | 'trip' | 'alert' | 'expense' | 'invoice' | 'system';
  tripId?: string;
  alertEventId?: string;
  expenseId?: string;
  invoiceId?: string;
  vehicleId?: string;
  /** Web route (e.g. /trips/abc) and app route (e.g. /trips/abc) — same shape. */
  route?: string;
}

export interface NotificationItem {
  id: string;
  titleAr: string;
  titleEn: string;
  bodyAr: string;
  bodyEn: string;
  data: NotificationData;
  readAt: string | null;
  createdAt: string;
}
